const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

const uploadImageToSt = file => {
  return sdk.images
    .upload(
      {
        image: file,
      },
      {
        expand: true,
      }
    )
    .then(res => {
      const imageId = res.data.data.id;
      return imageId;
    })
    .catch(e => {
      throw e;
    });
};

const updateProfilePic = id => {
  return sdk.currentUser
    .updateProfile({
      profileImageId: id,
    })
    .catch(e => {
      throw e;
    });
};

export const updateUserProfilePictureMaybe = async img => {
  if (!img) {
    return Promise.resolve('empty promise');
  }

  try {
    const profileImageId = await uploadImageToSt(img.file);
    const updatedUser = await updateProfilePic(profileImageId);
    return updatedUser;
  } catch (e) {
    return Promise.resolve('empty promise');
  }
};
